export enum EAppearanceField {
  DARK_MODE = 'darkMode',
  SELECTED_COLOR = 'selectedColor',
  DISPLAY_DENSITY = 'displayDensity',
  READING_PANE = 'readingPane',
  INBOX_TYPE = 'inboxType',
  CONTACT_SHOWN = 'contactShown',
  THREADING_SHOWN = 'threadingShown',
  CONTACT_ORDERING = 'contactOrdering',
  FOLDER_LIST_SIZE = 'folderListSize'
}
